import React from "react";

const UsageProgressBar = ({
  subscription,
  actionType,
  currentUsage,
  className = "",
  showLabel = true,
  showCount = true,
  height = "h-2",
}) => {
  if (!subscription || !subscription.features) {
    return null;
  }

  // Get the total limit from subscription features
  const limit = subscription.features[actionType] || 0;
  
  // Calculate percentage based on remaining quota
  // currentUsage here represents the remaining quota
  const percentage = limit > 0 ? Math.min(100, Math.max(0, (currentUsage / limit) * 100)) : 0;

  // Determine color based on usage percentage
  let barColor = "bg-green-500";

  if (percentage <= 10) {
    barColor = "bg-red-500";
  } else if (percentage <= 25) {
    barColor = "bg-yellow-500";
  } else if (percentage <= 50) {
    barColor = "bg-blue-500";
  }

  // Format the display labels
  const displayLabel = {
    requests: "Reports",
  };

  return (
    <div className={`w-full ${className}`}>
      {showLabel && (
        <div className="flex justify-between text-xs text-gray-400 mb-1">
          <span>{displayLabel[actionType] || actionType}</span>
          {showCount && (
            <span>
              {currentUsage} / {limit}
            </span>
          )}
        </div>
      )}
      <div
        className={`w-full bg-gray-700 rounded-full overflow-hidden ${height}`}
      >
        <div
          className={`${barColor} ${height} rounded-full transition-all duration-300`}
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default UsageProgressBar;